//常量
export const ACCESS_TOKEN = "Access-Token"; //访问令牌
export const USER_INFO = "USER_INFO"; //用户信息
export const ACCOUNT_TYPE = "ACCOUNT_TYPE"; //用户类型
export const SIDEBAR_TYPE = "SIDEBAR_TYPE"; //侧边栏类型
export const DEFAULT_THEME = "DEFAULT_THEME"; //默认主题
export const DEFAULT_LAYOUT_MODE = "DEFAULT_LAYOUT_MODE"; //默认布局模式
export const DEFAULT_COLOR = "DEFAULT_COLOR"; //默认颜色
export const DEFAULT_COLOR_WEAK = "DEFAULT_COLOR_WEAK"; //色弱颜色
export const DEFAULT_FIXED_HEADER = "DEFAULT_FIXED_HEADER"; //默认固定头部
export const DEFAULT_FIXED_SIDEMENU = "DEFAULT_FIXED_SIDEMENU"; //默认固定侧边栏菜单
export const DEFAULT_FIXED_HEADER_HIDDEN = "DEFAULT_FIXED_HEADER_HIDDEN"; //默认固定头部隐藏
export const DEFAULT_CONTENT_WIDTH_TYPE = "DEFAULT_CONTENT_WIDTH_TYPE"; //默认内容宽度类型(固定，流式)
export const DEFAULT_MULTI_TAB = "DEFAULT_MULTI_TAB"; //默认的页签(单页还是多页)
export const CREATE_HOUSE_STEP1_DATA = "CREATE_HOUSE_STEP1_DATA"; //创建房源时第一步数据缓存key

export const CONTENT_WIDTH_TYPE = {
  Fluid: "Fluid", //流体
  Fixed: "Fixed" //固定
};

export const ACCOUNT_TYPE_INFO = {
  NORMAL: "normal", //普通用户
  SYSTEM: "system" //系统管理用户
};
